import {
  mdiArchiveSearch,
  mdiChartBar,
  mdiCreditCard,
  mdiEmailAlert,
  mdiEye,
  mdiGroup,
  mdiHelpCircleOutline,
  mdiHome,
  mdiLayers,
  mdiListBox,
  mdiMagnify,
  mdiMapSearch,
  mdiTrendingUp
} from '@mdi/js'

export default [
  { header: 'Dashboard' },
  { href: '/', title: 'Dashboard Home', icon: mdiHome },
  { href: '/email_alerts', title: 'Your E-mail Alerts', icon: mdiEmailAlert, count: true },
  { href: '/groups', title: 'Your Fund Groups', icon: mdiGroup, count: true },
  { href: '/watchlists', title: 'Your Stock Watchlists', icon: mdiEye, count: true },
  { href: '/tracked_backtests', title: 'Your Tracked Backtests', icon: mdiTrendingUp, count: true },
  { href: '/whale_trader', title: 'WhaleTrader' },
  { href: '/whale_screener', title: 'WhaleScreener' },
  { href: '/trend_finder', title: 'Trend Finder', icon: mdiChartBar },
  { href: '/insider_dashboard', title: 'Insider Dashboard' },
  { href: '/analytics/backtester', title: '13F Backtester' },
  { href: '/search/fund_search', title: 'Fund Targeting Search', icon: mdiArchiveSearch },
  { href: '/global/global_search', title: 'Global Holdings Search', icon: mdiMapSearch },
  { header: 'Tools' },

  {
    title: '13F Analytics',
    group: '/analytics',
    icon: mdiChartBar,
    items: [
      { href: '/analytics/backtester?', title: '13F Backtester' },
      { href: '/analytics/consensus', title: 'Consensus Holdings' },
      { href: '/analytics/combined', title: 'Combined Holdings' },
      { href: '/analytics/double_down', title: 'Double-Down Report' },
      { href: '/analytics/overlapping_matrix', title: 'Overlap Matrix' },
      { href: '/analytics/early_bird_screener', title: '"Early Bird" Screener' }
    ]
  },
  {
    title: '13F Search Tools',
    group: '/search',
    icon: mdiMagnify,
    items: [
      { href: '/search/fund_performance_search', title: '13F Fund Performance Search' },
      { href: '/search/options_search', title: '13F Options Search' },
      { href: '/search/stock_screener', title: '13F Stock Screener' },
      { href: '/search/sector_search', title: '13F Sector Search' },
      { href: '/search/fund_correlation_search', title: 'Fund Correlation Search' }
    ]
  },
  {
    title: 'Other Dashboard Tools',
    group: '/other',
    icon: mdiLayers,
    items: [
      { href: '/other/schedule13', title: '13D/G Search' },
      { href: '/other/form_adv_search', title: 'Advisor Search (Form Adv)' },
      { href: '/other/form_d_search', title: 'Form D Search' },
      { href: '/other/form144_search', title: 'Form 144 Search' },
      { href: '/other/nsar_search', title: 'N-SAR Search' },
      { href: '/other/form4_search', title: 'Insider Transactions' },
      { href: '/insider_backtester', title: 'Insider Backtester' }
    ]
  },
  {
    title: 'ETF/Mutual Fund Tools',
    group: '/mutual_fund',
    icon: mdiLayers,
    items: [
      { href: '/mutual_fund/ncen_search', title: 'Mutual Fund (N-CEN) Search' },
      { href: '/mutual_fund/combined_mutual_fund', title: 'Combined Mutual Fund Report' }
      // { href: '/mutual_fund/portfolio_similarity', title: 'ETF Similar Portfolios' },
    ]
  },
  {
    title: 'Congressional Disclosures',
    group: '/congress',
    icon: mdiLayers,
    items: [
      { href: '/congress/congressional_transactions', title: 'Transaction Search' },
      { href: '/congress/congress_person_search', title: 'Congress Person Search' }
    ]
  },
  {
    title: 'Shorts',
    group: '/congress',
    icon: mdiLayers,
    items: [{ href: '/short/short_dashboard', title: 'Shorts Dashboard' }]
  },
  { header: 'Additional resources' },
  {
    title: 'Non Dashboard Pages',
    icon: mdiListBox,
    items: [
      { href: '/filing/latest_filings', title: 'Latest 13F Filings', external: true },
      { href: '/report/heat_map', title: '13F Heat Map', external: true },
      { href: '/info/excel_add_in', title: 'Excel Add-in', external: true },
      { href: '/statistics/trends', title: '13F Trend Charts', external: true },
      { href: '/info/statistics_tab', title: '13F Stats', external: true },
      { href: '/statistics/stock_statistics', title: '13F Stock Stats', external: true },
      { href: '/schedule13d', title: 'Latest 13D/G Filings', external: true },
      { href: '/ownership/index_by_day', title: 'Latest Insider Transactions', external: true },
      { href: '/whaleindex', title: 'WhaleIndex', external: true },
      {
        href: '/whaleindex/index/micro_small_mid',
        title: 'WhaleIndex Mid/Small/Micro',
        external: true
      },
      { href: '/pricing', title: 'Pricing', icon: mdiCreditCard, external: true }
    ]
  },
  {
    title: 'Site Help',
    icon: mdiHelpCircleOutline,
    items: [
      { href: '/whitepapers/whalewisdom', title: 'How Can WhaleWisdom Help You', external: true },
      { href: '/whitepapers/backtesting', title: 'Backtesting White Paper', external: true },
      { href: '/info/getting_started', title: 'Getting Started', external: true },
      { href: '/info/tutorial_videos', title: 'Video Tutorials', external: true },
      { href: '/info/faq', title: 'FAQ', external: true },
      { href: '/info/investing_13f', title: 'Whale University', external: true },
      { href: '/info/about', title: 'About', external: true },
      { href: '/articles', title: 'Blog and News', external: true },
      { href: '/info/contact', title: 'Contact Us', external: true }
    ]
  }
]
